import { SVGIconComponent } from './types';

export const LockerS: SVGIconComponent = ({ className, color, style }) => (
  <svg
    version="1.0"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 25 20"
    xmlSpace="preserve"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Locker-Sizes_x2F_locker-S">
      <g id="locker-S">
        <g id="S">
          <path
            id="path-1_00000132082116639248427840000003187296496789281206_"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
            d="M12.8,0l11.5,5.5c0.2,0.1,0.3,0.3,0.3,0.5
				l0,4.8c0,0.2-0.1,0.3-0.2,0.4l-11.6,8.4l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0
				c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0
				c0,0,0,0,0,0l-12-6.9C0.1,12.7,0,12.5,0,12.3V7.9c0-0.3,0.2-0.5,0.4-0.5l11.9-7.3C12.5,0,12.7,0,12.8,0z M1,8.8V12l11,6.3v-3.4
				L1,8.8z M23.6,7.2L13,14.8v3.4l10.6-7.6V7.2z M12.6,1.1L1.5,7.9L12.4,14l10.7-7.8L12.6,1.1z"
          />
        </g>
        <path
          id="S_00000083787329346863645520000009688601140259905185_"
          fill="currentColor"
          d="M12,10.9c1.4,0,2.2-0.7,2.2-1.8
			c0-0.9-0.5-1.3-1.6-1.6l-0.6-0.1c-0.7-0.2-1-0.4-1-0.8c0-0.5,0.4-0.8,1.1-0.8c0.6,0,1.1,0.3,1.1,0.8h1c0-1-0.9-1.6-2.1-1.6
			c-1.3,0-2.1,0.7-2.1,1.7c0,0.8,0.5,1.3,1.5,1.6l0.7,0.2c0.7,0.2,1,0.4,1,0.8c0,0.5-0.5,0.8-1.1,0.8c-0.7,0-1.2-0.3-1.3-0.8h-1
			C9.8,10.3,10.7,10.9,12,10.9z"
        />
      </g>
    </g>
  </svg>
);
